import React from 'react'
import axios from 'axios'
require('yamljs/dist/yaml');

const onLinkClick = (label) => {
  window.ga && window.ga('send','event','landing', 'click',label)
}

const fallbackDownloadLink = 'https://release.muzie.app/Muzie-1.5.1.dmg';
const baseDownloadUrl = 'https://release.muzie.app/Muzie-';

const onDownloadClick = async (e) => {
  e.preventDefault();
  try {
    const { YAML } = window;
    // need to enable CORS for * to test this on dev
    const { data: latestYml } = await axios.get('https://release.muzie.app/latest-mac.yml');
    const config = YAML.parse(latestYml);
    window.open(`${baseDownloadUrl}${config.version}.dmg` , '_blank');  
  } catch (error) {
    window.open(fallbackDownloadLink , '_blank');  
  }

  onLinkClick('download');
}

const Links = () => (        
  <ul className="actions">
    <li><a 
      href="#" 
      target="_blank" 
      onClick={onDownloadClick} 
      className="button cta"
    >
      Download for Mac
    </a></li>
    <li><a 
      href="https://www.patreon.com/gaafar" 
      target="_blank" 
      className="button"
      onClick={() => onLinkClick('patreon')} 
    >
      Support this project
    </a></li>
  </ul>
)

export default Links
